import { Injectable } from '@angular/core';
import { Countries } from 'src/app/components/auth/models/interface/countries.Interface';
import { environment } from 'src/environments/environment';
import { CityControllerClient } from '../../api/ph-web/city/city.apiServiceClientPb';
import { GetCountriesRequest, GetCountriesResponse } from '../../api/ph-web/city/city.api_pb';
import { CountryItemShared } from '../../models/interface/countryItem.interface';
import { GrpcFactoryService } from '../../sharedServices/grpc-factory.service';
import { MuHttpService } from '../../sharedServices/mu-http.service';

@Injectable({
  providedIn: 'root',
})
export class MuCityService {
  private cityClient = this.grpcFactoryService.create(
    CityControllerClient,
    `${environment.hostname}${environment.hostPort}`,
    'CityControllerClient'
  );

  private getCountriesListCall = this.grpcFactoryService.call(this.cityClient, this.cityClient.getCountries, {
    callName: 'getCountries',
  });

  constructor(private grpcFactoryService: GrpcFactoryService, private Muhttp: MuHttpService) {}

  /**
   * Get countries
   * @returns List of countries
   */
  async getCountries(): Promise<Countries[]> {
// eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      this.Muhttp.get(`${environment.hostnameApi}/countries`, {}).subscribe(
        (data: any) => {
          return resolve(data.data as Countries[]);
        },
        error => reject(error)
      );
    });
  }

  async getCountryList(): Promise<CountryItemShared[]> {
    const countriesListRequest = new GetCountriesRequest();

    const response: GetCountriesResponse = await this.getCountriesListCall(countriesListRequest);

    return response.getCountriesList().map(country => {
      return {
        id: country.getId(),
        iso: country.getIso(),
        name: country.getName(),
        active: country.getActive(),
        indicative: country.getIndicative(),
        currency: country.getCurrency(),
      };
    });
  }
}
